module.exports = __webpack_public_path__ + "./c98fa68ffd53a764ba672cc627b53bfc-service-image-json-large@2x.png";


//////////////////
// WEBPACK FOOTER
// ./plugins/services/src/img/service-image-json-large@2x.png
// module id = 1721
// module chunks = 0